// router.js
import { createBrowserRouter } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Layout from "./components/Layout/Layout";
import ProtectedRoute from './components/Auth/ProtectedRoute';
import RoleGuard from './components/Auth/RoleGuard';
import HomeRedirect from './components/Auth/HomeRedirect';
import VacancyRequestsPage from './pages/VacancyRequest';
import VacanciesPage from './pages/Vacancies';
import CandidatesPage from './pages/Candidates';
import TasksPage from './pages/Tasks';
import TaskDetailsPage from './pages/Tasks/Details';
import VacancyRequestDetailsPage from './pages/VacancyRequest/Details';
import VacancyDetailsPage from './pages/Vacancies/Details';
import CandidateDetailsPage from './pages/Candidates/Details';
import VacancyReportsPage from './pages/Reports/VacancyReports';
import RecruiterReportsPage from './pages/Reports/RecruiterReports';

export const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        children: [
            {
                index: true,
                element: <HomeRedirect />
            },
            {
                element: <ProtectedRoute />,
                children: [
                    {
                        path: 'dashboard',
                        element: <Dashboard />
                    },
                    {
                        path: 'profile',
                        element: <Profile />
                    },
                    {
                        element: <RoleGuard deny={["employee"]} redirectTo="/tasks" />,
                        children: [
                            {
                                path: 'vacancy-requests',
                                element: <VacancyRequestsPage />,
                                children: [
                                    {
                                        path: ':id',
                                        element: <VacancyRequestDetailsPage />
                                    }
                                ]
                            },
                            {
                                path: 'vacancies',
                                element: <VacanciesPage />,
                                children: [
                                    {
                                        path: ':id',
                                        element: <VacancyDetailsPage />
                                    }
                                ]
                            },
                            {
                                path: 'candidates',
                                element: <CandidatesPage />,
                                children: [
                                    {
                                        path: ':id',
                                        element: <CandidateDetailsPage />
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'tasks',
                        element: <TasksPage />,
                        children: [
                            {
                                path: ':id',
                                element: <TaskDetailsPage />
                            }
                        ]
                    },
                    {
                        element: <RoleGuard allow={["superadmin", "admin", "hr"]} deny={["leader", "user"]} redirectTo="/tasks" />,
                        children: [
                            {
                                path: 'reports/vacancies',
                                element: <VacancyReportsPage />
                            },
                            {
                                path: 'reports/recruiters',
                                element: <RecruiterReportsPage />
                            }
                        ]
                    }
                ]
            }
        ]


    },
    {
        path: 'login',
        element: <Login />
    },
    {
        path: 'register',
        element: <Register />
    },
], {
    basename: '/service'
});
